import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-22192718"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "left-user"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<img class=\"ac_img\" src=\"\" alt=\"\" data-v-22192718><div class=\"box_right\" data-v-22192718><div class=\"name_s\" data-v-22192718><span class=\"name\" data-v-22192718>谢志勇</span></div><div class=\"mesage\" data-v-22192718><span class=\"item_s\" data-v-22192718>怎么这么傻逼，什么玩意,真勾八无语，什么 bbblailai</span></div></div>", 2);
const _hoisted_5 = [_hoisted_3];
import { ref } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'left-user',
  setup(__props) {
    const actives = ref(0);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(20, (item, index) => {
        return _createElementVNode("div", {
          key: index,
          class: _normalizeClass(["item-box", index == actives.value ? 'item-box-bg' : '']),
          onClick: $event => actives.value = index
        }, _hoisted_5, 10, _hoisted_2);
      }), 64))]);
    };
  }
});